import React from 'react'
import Header from '../component/Header'
import Footer from '../component/Footer'
import { color, motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {

  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.18,
        delayChildren: 0.2,
      },
    },
  };

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <>
      <Header />

      <section className=" text-black py-16 px-4 md:px-10">
        <motion.div
          variants={container}
          initial="hidden"
          animate="visible"
          className="max-w-5xl mx-auto"
        >
          <motion.h1
            variants={fadeUp}
            className="text-4xl md:text-5xl font-bold mb-10 text-blue-800"
          >
            Privacy Policy
          </motion.h1>

          <motion.div
            variants={fadeUp}
            className="space-y-8 text-gray-300 leading-8"
          >
            <div>
              <p style={{color:"black"}}>
                This website (
                <a
                  href="https://b4salary.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-800"
                >
                  https://b4salary.com
                </a>
                ) and the B4SALARY mobile application (collectively referred to
                as the “website,” “services,” or “app”) are owned and operated
                by <Link to="https://kisgaleasing.com" target='_blank'>Kisga Leasing and Finance Pvt Ltd.</Link>, a company incorporated
                under the Companies Act, 1956, with its registered office at
                B-7, New Multan Nagar, Paschim Vihar, New Delhi - 110056.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-blue-800 mb-3">
                Consent
              </h2>
              <p style={{color:"black"}}>
                By using the B4SALARY platform, you explicitly consent to share
                the information required for availing the services offered.
                B4SALARY may collect and use your information as outlined in
                this Privacy Policy to facilitate lending and non-lending
                services in collaboration with financial institutions,
                third-party partners, and service providers.
              </p>

              <p className="mt-4"style={{color:"black"}}>
                By accepting this Privacy Policy, you expressly consent to
                B4SALARY's collection, retention, analysis, use, and disclosure
                of your information as described herein.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-blue-800 mb-4">
                Annexure 1 – Permissions
              </h2>

              <div className="space-y-5">
                <div>
                  <h3 className="text-xl font-semibold text-white">
                    Camera & Microphone
                  </h3>
                  <p style={{color:"black"}}>
                    Access may be required for selfies, document uploads, and
                    audio/video recordings for onboarding, verification, or KYC
                    purposes.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-white">
                    Location
                  </h3>
                  <p style={{color:"black"}}>
                    Location data may be collected to verify address, assess
                    serviceability, detect fraud, and underwrite customers.
                    Location access is enabled only with your consent.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-white">
                    Device Information
                  </h3>
                  <p style={{color:"black"}}>
                    Device-related data such as IP address, OS, browser,
                    hardware model, and timestamps may be collected to prevent
                    unauthorized access and fraud.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-white">
                    Phone Storage
                  </h3>
                  <p style={{color:"black"}}>
                    Storage permission is required to upload identity documents,
                    bank statements, and related files during loan application.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-white">
                    SMS Access
                  </h3>
                  <p style={{color:"black"}}>
                    B4SALARY reads only non-personal SMS from 6-digit
                    alphanumeric senders related to financial transactions.
                    Personal messages and third-party OTPs are not accessed.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-white">
                    Installed Applications
                  </h3>
                  <p style={{color:"black"}}>
                    The app may collect a list of installed applications via
                    trusted partner Credeau to assess risk and detect fraud.
                    Data is collected only after explicit consent.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-white">
                    Phone State
                  </h3>
                  <p style={{color:"black"}}>
                    SIM status and network strength are checked for onboarding
                    and fraud prevention. Contacts and call logs are never
                    collected.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-blue-800 mb-3">
                Information We Collect
              </h2>

              <p className="mb-4" style={{color:"black"}}>
                We may collect personal, financial, device, and transactional
                information required for loan eligibility, compliance, fraud
                detection, and service delivery.
              </p>

              <ul className="list-disc pl-6 space-y-2" style={{color:"black"}}>
                <li>
                  Personal details (name, address, DOB, photograph)
                </li>
                <li>Contact details (email, phone number)</li>
                <li>
                  Financial information (bank accounts, transactions, credit
                  history)
                </li>
                <li>Device data (location, IP address, logs)</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-blue-800 mb-3">
                Purpose of Data Collection
              </h2>

              <ul className="list-disc pl-6 space-y-2" style={{color:"black"}}>
                <li>Provide requested products and services</li>
                <li>Assist partners in credit assessment</li>
                <li>Prevent fraud and comply with legal obligations</li>
                <li>Communicate service updates and offers</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-blue-800 mb-3">
                Third-Party Policies
              </h2>

              <p style={{color:"black"}}>
                B4SALARY may share information with banks, NBFCs, credit
                bureaus, and service providers. These third parties have
                independent privacy policies, and we recommend reviewing them.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-blue-800 mb-3">
                Data Retention & Account Deletion
              </h2>

              <p style={{color:"black"}}>
                Users may withdraw consent, request corrections, or delete their
                app account by contacting{" "}
                <a
                  href="mailto:care@b4salary.com"
                  className="text-blue-800"
                >
                  care@b4salary.com
                </a>
                . Legal or regulatory obligations may require certain data
                retention.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-blue-800 mb-3">
                Contact Information
              </h2>

              <p style={{color:"black"}}>Email: care@b4salary.com</p>
              <p style={{color:"black"}}>
                Address: B-7, New Multan Nagar, Paschim Vihar, New Delhi -
                110056
              </p>
            </div>
          </motion.div>
        </motion.div>
      </section>

      <Footer />
    </>
  )
}